export default "__VITE_ASSET__BEcwMV7Y__"